import { AnimatePresence, motion } from "motion/react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const NAV_ITEMS = [
    { label: "Collection", path: "/collection" },
    { label: "Our Story", path: "/our-story" },
    { label: "Sustainability", path: "/sustainability" },
    { label: "Journal", path: "/journal" },
    { label: "Contact", path: "/contact" },
];

interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    className="fixed inset-0 z-[60] bg-white p-8 flex flex-col"
                >
                    <div className="flex justify-end">
                        <button onClick={onClose} className="p-2">
                            <X size={32} strokeWidth={1} />
                        </button>
                    </div>
                    <div className="flex-1 flex flex-col justify-center gap-8">
                        {NAV_ITEMS.map(({ label, path }) => (
                            <Link
                                key={path}
                                to={path}
                                className="font-serif text-5xl text-left hover:italic transition-all"
                                onClick={onClose}
                            >
                                {label}
                            </Link>
                        ))}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
